import React from 'react';
import NavBar from './NavBar.jsx';
import ReactDOM from 'react-dom';
import Ajax from "./AJAX.jsx";
import RecursiveField2 from "./RecursiveField2.jsx";
import InteractiveTable from './InteractiveTable.jsx';
import UpdateDataForm from './UpdateDataForm.jsx';
import ChangePositionView from './ChangePositionView.jsx';
import {DropDownMultiSelector} from "./DropDownSelector.jsx";
import DrawPosition from "./DrawPosition.jsx";
import * as tools from "./tools.jsx";
import {ConfirmModal} from "./ConfirmModal.jsx";
import {CompPlayer} from "./genericCompPlayer.js";

const HideCompositionId = (props) =>
{
   return(
      <span>
         {props.value} (Cannot be edited)
      </span>
      );
}

class UnpublishedSection  extends React.Component
{
   constructor(props)
   {
      super(props);

        this.extraBtns = [
         {name:'edit', click:this.props.clickedEdit},
         {name:'remove', click:this.props.removeComposition},
         {name:"play", click:this.props.clickedPlay}
      ];
   }

   submitCompositions()
   {
      const self = this;
      for(var i = 0; i < self.props.unpublishedCompositions.length; i++)
      {
         const thisComp = self.props.unpublishedCompositions[i];
         
         const compositionSubmitted = (response)=>
         {
            if(response.success)
            {
               self.props.requestCompDataUpdate();
            }
            else
            {
               self.props.appCallbacks.showResponseErr(response, "Submit Composition Error");
            }
         }
         this.props.appCallbacks.performAjaxRequest('compositions/' + thisComp.composition_id, "PUT", Object.assign({}, thisComp, {published:1}), compositionSubmitted, false);
      };
   }

   render()
   {
      const self = this;
      const compsExist = self.props.unpublishedCompositions.length != 0;
      const compsAreUploaded = compsExist && self.props.uploadsInProgress.length == 0;
      const compHavePositions =  compsExist && !self.props.unpublishedCompositions.find((comp)=>comp.position.lat == 0 || comp.position.lng == 0);
      const allCompsReady = compsExist && compsAreUploaded && compHavePositions;

      const CheckMark = (props)=>{return(<span style={{fontSize:20, fontWeight:"bold"}}>{props.checked ? "(V)" : "(-)"}</span>)}
      
      const hideCols = ['file_name', 'composition_id', "published"];

      const buttonStyle =
      {
         fontSize:24,
         opacity: allCompsReady ? 1 : 0.3,
      }
     
      return (
         <div>
         {self.props.unpublishedCompositions.length == 0 ? null :
            <div style={{display:"block"}}>
            <h2 style={{display:'block'}}> Unsubmitted:</h2>
               <InteractiveTable interpreter={self.props.getInterpreter()} extraBtns={self.extraBtns}
                  hideColumns={hideCols} rowObjects={self.props.unpublishedCompositions}/>
            </div>
         }
         {self.props.uploadsInProgress.length == 0 ? null :
            <div>
               <span>Uploading files: </span>
               {self.props.uploadsInProgress.map((u,i)=><span key={i}>{u.name}</span>)}
            </div>
         }
         
            <button style={buttonStyle} onClick={allCompsReady ? self.submitCompositions.bind(self) : null}>Submit</button>
            <div style={{float:"right", paddingRight:"10px"}}>To submit - all files must:
               <span>* be done uploadsInProgress  </span><CheckMark checked={compsAreUploaded}/>
               <span>* have a valid position  </span><CheckMark checked={compHavePositions}/>
            </div>
         </div>
      )
   }
}

class CompositionList extends React.Component {
     constructor(props)
   {
      super(props);
      
      //Set initial state
      this.state = {
         uploadsInProgress: [],
         unpublishedCompositions: [],
         publishedCompositions: [],
          
         data_contexts: [],
         data_users: [],
         data_tags: [],
         hasTriedReadingData: false,
      }
      
       this.compsExtraBtns = [
         {name:'edit', click:this.clickedEdit.bind(this)},
         {name:'remove', click:this.removeComposition.bind(this)},
         {name:"play", click:this.clickedPlay.bind(this)}
      ];

      this.compPlayer = new CompPlayer((msg)=>{this.props.appCallbacks.showMsg("Comp Player:", msg)});
      //Bind functions
      /*this.filesSelectedForUpload.bind(this);
      this.clickedEdit.bind(this);
      this.showEditComposition.bind(this);
      this.removeFileFromUpload.bind(this);
      this.submitCompositions.bind(this);
      this.receiveCompositions.bind(this);
      */

      //Once for all calculations
    


   }
   //fileupload->compositionPost cycle
   filesSelectedForUpload(e)
   {
      const self = this;
      //console.log(e.target.files);

      if(self.props.user.contexts.length == 0)
      {
         self.props.appCallbacks.showMsg("No Contexts avaialable", "logged in user does not have access to any contexts, and thus cannot add composition (which must have a context)");
         return;
      }

      for(var i = 0; i < e.target.files.length; i++)
      {
         const file = e.target.files[i];

         self.setState((prevState, props)=>{return{uploadsInProgress:[...prevState.uploadsInProgress, file]}});

         const fileUploaded = (response)=>
         {
            if(response.success)
            {
               //console.log("File Uploaded: " + file.name);
               //Remove file from uploading
               
               //Setup new standard composition
               const comp =
               {
                  name:file.name,
                  file_name:response.result.onlineFileName,
                  position:{lat:0, lng:0},
                  user_id:response.user.user_id,
                  publisher_user_id: response.user.user_id,
                  published:0,
                  context_id: response.user.contexts.length == 0 ? -1 : response.user.contexts[0],
               }

               const compUploaded = (response)=>
               {
                  if(response.success)
                  {
                     self.setState((prevState, props)=>{return {uploadsInProgress:prevState.uploadsInProgress.filter((f)=>f!=file)}});

                     //console.log("Compositions uploaded: " + file.name);
                     
                     self.props.appCallbacks.performAjaxRequest("compositions", "GET", null,
                        self.receiveCompositions.bind(self), false);
                  }
                  else
                  {
                     self.props.appCallbacks.showResponseErr(response, "Upload Composition Error");
                  }
               }

               self.props.appCallbacks.performAjaxRequest('compositions', "POST", comp, compUploaded, false);
            }
            else
            {
               self.props.appCallbacks.showResponseErr(response, "File Upload Error");
            }
            
         } 

         self.props.appCallbacks.performAjaxRequest('audioFile', "POST", file, fileUploaded, true);
      }
   }


   clickedEdit(comp)
   {
      this.showEditComposition(comp)
   }

   clickedPlay(comp)
   {
      this.compPlayer.togglePlayComp(comp);
   }
      
   showEditComposition(comp)
   {
      const self = this;

      var onSaveEdit = function(editedComp)
      {
         if(editedComp != null)
         {
            //Check if context is available to selected user
            const compUser = self.state.data_users.find((u)=>u.user_id == editedComp.user_id);

            const selectedContext = self.state.data_contexts.find((c)=>c.context_id == editedComp.context_id);
            
            /*if(!compUser.contexts.find((cId)=>cId == editedComp.context_id))
            {
               const err ="Composition context set to: " + selectedContext.name +
                  " which is unavailable to user: " + compUser.name;
               self.props.appCallbacks.popModal();
               self.showEditComposition(comp);
               return;
            }
*/
            const donePuttingCompositions = (response) =>
            {
               if(response.success)
               {
                  //console.log("Done putting new values.");
                  self.props.appCallbacks.performAjaxRequest("compositions", "GET", null,
                  self.receiveCompositions.bind(self), false);
                  self.props.appCallbacks.popModal();
               }
               else
               {
                  self.props.appCallbacks.showResponseErr(response, "Edit Composition Error");
               }
            }
            //console.log("Putting comp: ", editedComp);
            self.props.appCallbacks.performAjaxRequest('compositions/' + editedComp.composition_id, "PUT", editedComp, donePuttingCompositions, false);
         }
         else
         {
            self.props.appCallbacks.popModal();
         }
      }
      

      

      var drawFunctions =
      {
         context_id:DropDownMultiSelector,
         user_id:DropDownMultiSelector,
         position:DrawPosition,
         composition_id:HideCompositionId,
         published:HideCompositionId,
         publisher_user_id:HideCompositionId,
         file_name:HideCompositionId,
         tags:DropDownMultiSelector,
      };
      
      const contextObjects = self.state.data_contexts.map((con)=>{return({id:con.context_id, name:con.name});})
      const userObjects = self.state.data_users.map((u)=>{return({id:u.user_id, name:u.name});})
      const tagsObjects = self.state.data_tags.map((t)=>{return({id:t.tag_id, name:t.name});})
      

      var drawFuncObjects =
      {
         position:{
            popModal:self.props.appCallbacks.popModal,
            pushModal:self.props.appCallbacks.pushModal,
         },
         user_id:{objects: userObjects, selectSingle:true},
         context_id:{objects: contextObjects, selectSingle:true},
         tags:{objects:tagsObjects},
      };         

      
      var modalProps = {
         saveCallback:onSaveEdit.bind(self),
         heading:"Edit New Composition Data",
         data:comp,
         drawFuncs:drawFunctions,
         drawFuncObjects:drawFuncObjects,
      };

      self.props.appCallbacks.pushModal({modalClass:UpdateDataForm, modalProps:modalProps});
      
   }

      
   removeComposition(comp){
      const self = this;

      const onConfirmDelete = ()=>
      {
         const onServerDelete = (response)=>
         {
            if(response.success)
            {
               self.props.appCallbacks.performAjaxRequest("compositions", "GET", null,
                     self.receiveCompositions.bind(self), false);
            }
            else
            {
               self.props.appCallbacks.showResponseErr(response, "Remove Composition Error");
            }
         }

         self.props.appCallbacks.performAjaxRequest("compositions/" + comp.composition_id, "DELETE", null,
            onServerDelete, false);
      }

      const modalProps = {
         heading: "Confirm Delete",
         msg:"Delete Composition: " + comp.name + " ?",
         onConfirm:onConfirmDelete,
         popModal: self.props.appCallbacks.popModal,
      }
      self.props.appCallbacks.pushModal({modalClass:ConfirmModal, modalProps:modalProps});
   }


  

   receiveCompositions(response)
   {
      if(response.success)
      {
          const addToState = (prevState, props) => //Function is written separately to be clear
         {
            const unpublished = response.result.filter((cNew)=> cNew.published == false && cNew.publisher_user_id == props.user.user_id);

            const published = response.result.filter((c)=>c.published == 1);
            //const newUnpublished = unpublished.filter((cNew)=>
            //   !prevState.unpublishedCompositions.find((cOld)=>cOld.composition_id == cNew.composition_id));

            return {unpublishedCompositions: unpublished, publishedCompositions: published};

         }
         this.setState(addToState);
       }
       else
       {
         this.props.appCallbacks.showResponseErr(response, "Receive Compositions Error");
       }
   }

   readDataIfNotReadAndUserExists()
   {
     if(this.props.user)
      {
         if(!this.state.hasTriedReadingData)
         {
            this.refreshCompData();

            this.props.appCallbacks.performAjaxRequest("contexts", "GET", null,
               tools.getSetBaseDataFunc(this, "data_contexts"), false);

            this.props.appCallbacks.performAjaxRequest("tags", "GET", null,
               tools.getSetBaseDataFunc(this, "data_tags"), false);

            this.props.appCallbacks.performAjaxRequest("users", "GET", null,
               tools.getSetBaseDataFunc(this, "data_users"), false);
            
            this.setState({hasTriedReadingData:true});
         }
      }
   }
    
   refreshCompData()
   {
      this.props.appCallbacks.performAjaxRequest("compositions", "GET", null,
               this.receiveCompositions.bind(this), false);
   }  

   componentWillUpdate()
   {
      this.readDataIfNotReadAndUserExists();
   }

   componentDidMount()
   {
      this.readDataIfNotReadAndUserExists();
   }

   getInterpreter()
   {
      const getUser = (id)=>this.state.data_users.find((u)=>u.user_id==id);
      const getContext = (id)=>this.state.data_contexts.find((c)=>c.context_id==id);
      const getTags = (ids)=> this.state.data_tags.filter((t)=>ids.indexOf(t.tag_id) != -1);
      return (
      {
         user_id:(id)=>{const user = getUser(id) ; return user ? user.name : id;},
         context_id:(id)=>{const context = getContext(id) ; return context ? context.name : id;},
         tags: (ids)=>{var tagLin = "";getTags(ids).forEach((t)=>tagLin += "#" + t.name+ ", "); return tagLin;},
         publisher_user_id: (id)=> {const user = getUser(id) ; return user ? user.name : id;},
         //context_id:(id)=>"OLE!" + this.state.data_contexts[0].name,
      });
   }
   componentWillUnmount()
   {
      this.compPlayer.tearDown();
   }

   render() {

      const self = this;

      const state = self.state;

      const hideCols = ['file_name', 'composition_id', "published"];

      const searchFilteredPublishedComps = this.props.pageData.restrictions ?
         tools.filterArrayWhereAllRestrictionsMet(state.publishedCompositions, this.props.pageData.restrictions) :
         state.publishedCompositions;

      //console.log("Rendering compositions with pageData: ", this.props.pageData);
      return (
         <div>
         
             <div>
               <h1 style={{display:'inline-block'}}> Compositions</h1>
               <div style={{float:"right", display: "inline-block", verticalAlign: "middle", lineHeight: 5}}>
                  Upload Files: <input type="file" id="fileUpload" multiple size = '10' accept=".aac" onChange={this.filesSelectedForUpload.bind(this)}/>
               </div>
            </div>
            <div>
               {state.unpublishedCompositions.length == 0 && state.uploadsInProgress.length == 0 ? null :
                  <UnpublishedSection getInterpreter={self.getInterpreter.bind(self)} unpublishedCompositions={state.unpublishedCompositions}
                  uploadsInProgress={state.uploadsInProgress} clickedEdit={self.clickedEdit.bind(this)}
                  clickedPlay={self.clickedPlay.bind(this)} removeComposition={self.removeComposition.bind(this)} requestCompDataUpdate={self.refreshCompData.bind(this)}
                  appCallbacks={self.props.appCallbacks} />}
                  
               {state.unpublishedCompositions.length == 0 ? null :
                  <h2 style={{display:'block'}}> Submitted:</h2> }

               {searchFilteredPublishedComps.length/*state.publishedCompositions.length*/ == 0 ? null :
                  <InteractiveTable rowObjects={searchFilteredPublishedComps/*state.publishedCompositions*/} interpreter={self.getInterpreter()}
                  extraBtns={self.compsExtraBtns} hideColumns={hideCols}/>
               }
            </div>
         </div>
      );
   }
}

export default CompositionList;


// WEBPACK FOOTER //
// ./js/CompositionList.jsx